function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, "\n      .cls-1 {\n      fill: #fff;\n      }\n    "));

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M85.45,216.34h14.7v24.7h0c2.66-4.85,8.87-7.94,14.19-7.94,15.52,0,16.85,11.91,16.85,18.52v30.87h-15.52v-22.82c0-6.58.86-13.16-7.33-13.16-5.6,0-8.19,4.83-8.19,10.09v25.89h-14.7v-66.16Z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M138.54,249.76c.44-6.18,3.09-10.6,7.07-12.8,3.98-2.21,9.28-3.53,14.58-3.53,11.04,0,21.64,2.65,21.64,16.34v21.19c0,3.97,0,8.39,1.77,12.36h-15.02c-.44-1.32-.88-3.09-.88-4.42-3.98,4.42-9.72,6.18-15.02,6.18-8.83,0-15.9-4.86-15.9-14.57,0-15.89,16.34-14.57,26.95-16.78,2.65-.44,3.98-1.32,3.98-4.42,0-3.53-3.98-4.86-7.07-4.86-3.98,0-6.63,1.77-7.51,6.18h-14.58v-.88h0ZM158.29,274.48c7.02,0,9.65-4.39,9.22-14.04-2.19,1.32-6.14,1.76-9.22,2.63-3.51.88-6.14,2.19-6.14,6.14,0,3.51,2.63,5.27,6.14,5.27"
});

var _ref5 =
/*#__PURE__*/
React.createElement("rect", {
  className: "cls-1",
  x: 189.18,
  y: 217.16,
  width: 14.7,
  height: 66.16
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M267.55,233.23c12.73,0,21.06,7.46,19.31,21.06-1.76,17.11-13.6,29.4-29.84,29.4-12.73,0-21.06-6.58-19.75-20.62,1.76-17.11,13.6-29.84,30.28-29.84M258.34,272.28c8.34,0,12.73-10.09,13.16-17.11.44-6.14-.88-10.09-6.58-10.09-8.34,0-12.29,10.97-13.16,17.55,0,5.27,1.32,9.65,6.58,9.65"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M240.19,234.31h-9.36v-2.31c0-4.62,2.23-5.08,5.79-5.08,1.34,0,2.67,0,4.01.46v-12c-2.23-.46-4.9-.46-7.57-.46-12.92,0-17.82,4.62-17.82,19.39h-7.28s0,10.62,0,10.62h7.35v38.39h14.7v-38.39h5.72l4.46-10.62Z"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M292.09,272.7v-38.39h14.7v8.13h0c2.01-5.7,7.27-8.78,13.42-8.78.88,0,2.19,0,3.07.44l-.88,1.76-3.95,10.7h-.88c-7.46.27-11.41,5.54-11.6,11.24v25.51h-14.7v-10.62h.82Z"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M369.3,283.32h-14.32v-5.27h0c-2.86,4.39-6.94,7.02-11.84,7.02-13.48,0-19.19-13.16-19.19-26.77,0-12.73,5.72-24.57,17.97-24.57,5.31,0,9.39,2.19,12.25,6.58v-23.97h14.7v66.98h.43ZM336.88,258.24c0,6.58,2.19,14.04,9.22,14.04,7.46,0,8.78-7.46,8.78-13.6,0-7.02-2.19-13.6-8.78-13.6-6.58,0-9.22,7.02-9.22,13.16"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M393.93,283.69c-7.9,0-13.6-2.19-19.31-5.7l4.39-12.29c4.83,3.51,10.53,6.14,14.92,6.14,3.95,0,5.27-1.32,5.27-3.07,0-6.14-22.38-2.19-22.38-18.43,0-9.65,8.34-16.24,19.75-16.24,5.7,0,12.73,2.19,17.55,4.83l-4.39,11.85c-4.83-2.63-9.65-4.39-13.6-4.39-3.07,0-4.83,1.32-4.83,3.07,0,6.14,23.26,2.19,23.26,19.75,0,8.34-8.78,14.48-20.62,14.48"
});

var SvgChasHalfordsLogo = function SvgChasHalfordsLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    width: 180,
    height: 150,
    style: {
      backgroundColor: "#FF9718"
    },
    viewBox: "110 130 250 250",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgChasHalfordsLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chas-halfords-logo.30d7ce92.svg";
export { ForwardRef as ReactComponent };